import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAddress } from './selectHouseAddress';

export const selectHouseShortAddress = createSelector(selectHouseAddress, address =>
  address
    .reduce(
      (result, { type, fullName }) =>
        ['location', 'raion', 'district'].includes(type) ? [...result, fullName] : result,
      [],
    )
    .join(', '),
);
